import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ChangeEvent, ReactElement } from 'react';
import moment from 'moment';

// Core + Store
import { ILearnerResult } from 'core';

// Misc
import { Credits } from './Credits';

// Styles
import styles from './TranscriptCard.module.scss';
import { visuallyHidden } from '@mui/utils';

// Types
interface IProps {
  isSelected?: boolean;
  onSelect?({ e, learnerActivity }: { e: ChangeEvent<HTMLInputElement>; learnerActivity: ILearnerResult }): void;
  learnerActivity?: ILearnerResult;
}

export const TranscriptCard = (props: IProps): ReactElement => {
  const { isSelected, onSelect, learnerActivity } = props;
  const { activityTitle, completionDate, credits, key, provider, activityFormat, contentTags } = learnerActivity;

  return (
    <Box className={styles.card} sx={{ p: 4, mt: 3, mb: 3 }}>
      <Grid container>
        {/* Checkbox column */}
        {onSelect && (
          <Grid>
            <label className={styles.checkbox} htmlFor={key}>
              <input id={key} type="checkbox" checked={isSelected} onChange={(e) => onSelect({ e, learnerActivity })} />
              <span className="checkmark" />
              <span style={visuallyHidden}>{activityTitle}</span>
            </label>
          </Grid>
        )}
        {/* Main card content column */}
        <Grid size={{ xs: 11 }}>
          <h1 className={styles.heading}>{activityTitle}</h1>
          <Box className={styles['pipe-separated']} sx={{ display: 'flex', mb: 1, mt: 1 }}>
            <Box>Completed {moment(completionDate).format('M/D/YYYY')}</Box>
            <Box>{provider}</Box>
            <Box>{activityFormat}</Box>
          </Box>
          {contentTags?.length > 0 &&
            (() => {
              const grouped = contentTags.reduce(
                (acc, tag) => {
                  const domain = tag.stateContentDomain?.trim();

                  if (!domain) {
                    return acc;
                  }

                  if (!acc[domain]) {
                    acc[domain] = [];
                  }

                  const topic = tag.stateContentTopic?.trim();

                  if (topic && !acc[domain].includes(topic)) {
                    acc[domain].push(topic);
                  }

                  return acc;
                },
                {} as Record<string, string[]>,
              );

              const parts = Object.keys(grouped)
                .sort((a, b) => a.localeCompare(b))
                .map((domain) => {
                  const topics = grouped[domain].sort((a, b) => a.localeCompare(b));

                  return topics.length ? `${domain}: ${topics.join(', ')}` : domain;
                });

              if (parts.length === 0) {
                return null;
              }

              return (
                <div>
                  <div>*Content Meets State Licensing Requirements for the following Content Area(s):</div>
                  <div>
                    <i>{parts.join('; ')}</i>
                  </div>
                </div>
              );
            })()}

          {!!credits?.length && (
            <Grid container spacing={1}>
              <Credits credits={credits} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
